import { Component } from '@angular/core';
import { DocService } from '../services/doc.service';

@Component({
	selector: 'loading-popup',
	templateUrl: './loading-popup.component.html',
	styleUrls: ['./loading-popup.component.scss']
})
export class LoadingPopupComponent {

	constructor(private _docService: DocService) { }

	public get show(): boolean {
		return this._docService.ShowLoader;
	}
}
